import React from "react";
import PropTypes from "prop-types";
import { Menu, Icon, Tag } from "antd";
import _upperCase from "lodash/upperCase";
import _sum from "lodash/sum";
import { PermissionContextConsumer } from "hocs/permission-context-manager";

import "styles/vertical-menu.css";

const MenuItem = ({ value }) => (
    <div className={"d-flex justify-content-space-between align-items-center"}>
        {value.icon ? <Icon type={value.icon} /> : null}
        <div>{value.label}</div>
        {value.tag}
    </div>
);

MenuItem.propTypes = {
    value: PropTypes.object
};

class NavigationMenu extends React.Component {
    navigate = e => {
        if (/\/\w/.test(e.key)) {
            this.props.history.push(e.item.props.target || e.key);
        }
    };
    render() {
        const { menuItems, caseCount } = this.props;
        return (
            <PermissionContextConsumer>
                {context => (
                    <Menu
                        selectedKeys={[this.props.location.pathname]}
                        onClick={this.navigate}
                        mode="vertical"
                        className={"vertical-menu"}
                    >
                        {menuItems
                            .map((value, key) =>
                                !value.permission ||
                                context.get(value.permission) ? (
                                        <Menu.Item
                                            key={value.target || key}
                                            target={value.target}
                                        >
                                            <MenuItem
                                                value={{
                                                    ...value,
                                                    tag: value.tag ? (
                                                        <Tag color={"#87d068"}>
                                                            {_sum(
                                                                _upperCase(
                                                                    value.label
                                                                ) === "INBOX"
                                                                    ? caseCount
                                                                        .getIn([
                                                                            _upperCase(
                                                                                value.label
                                                                            ),
                                                                            "data"
                                                                        ])
                                                                        .filter(
                                                                            (
                                                                                _,
                                                                                k
                                                                            ) =>
                                                                                k !==
                                                                              "My Cases"
                                                                        )
                                                                        .toList()
                                                                        .toArray()
                                                                    : caseCount
                                                                        .getIn([
                                                                            _upperCase(
                                                                                value.label
                                                                            ),
                                                                            "data"
                                                                        ])
                                                                        .toList()
                                                                        .toArray()
                                                            )}
                                                        </Tag>
                                                    ) : null
                                                }}
                                            />
                                        </Menu.Item>
                                    ) : null
                            )
                            .toList()
                            .toJS()}
                    </Menu>
                )}
            </PermissionContextConsumer>
        );
    }
}

NavigationMenu.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    menuItems: PropTypes.object,
    caseCount: PropTypes.object
};

export default NavigationMenu;
